module.exports = __webpack_public_path__ + "img/onboarding_update_profile_pl.79724371.png";